import { render } from "./ApproveArtProductModal.vue?vue&type=template&id=0811c7d2"
import script from "./ApproveArtProductModal.vue?vue&type=script&lang=js"
export * from "./ApproveArtProductModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__